import React from 'react';

interface GradientCheckboxProps {
  checked: boolean;
  className?: string;
}

export function GradientCheckbox({ checked, className = '' }: GradientCheckboxProps) {
  if (checked) {
    return (
      <svg viewBox="0 0 24 24" fill="none" className={`h-4 w-4 flex-shrink-0 ${className}`}>
        <defs>
          <linearGradient id="gc-fill" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#E91E8C" />
            <stop offset="100%" stopColor="#F97316" />
          </linearGradient>
        </defs>
        <circle cx="12" cy="12" r="12" fill="url(#gc-fill)" />
        <path
          d="M7.5 12.5l3 3 6-6.5"
          stroke="white"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 24 24" fill="none" className={`h-4 w-4 flex-shrink-0 ${className}`}>
      <defs>
        <linearGradient id="gc-stroke" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#E91E8C" />
          <stop offset="100%" stopColor="#F97316" />
        </linearGradient>
      </defs>
      <circle cx="12" cy="12" r="10" stroke="url(#gc-stroke)" strokeWidth="1.5" />
    </svg>
  );
}
